module.exports = __webpack_public_path__ + "static/media/delivery icon 3.26e9529c.png";